import { FC, ReactNode } from 'react';

interface AvisoProps {
  icone: string;
  cor: string;
  titulo: string;
  children: ReactNode;
  testId: string;
}

/** Aviso que muda a leitura dos números (réplica parada, dado incompleto…): ícone + título, nunca só cor. */
const Aviso: FC<AvisoProps> = ({ icone, cor, titulo, children, testId }) => (
  <div
    role="status"
    data-testid={testId}
    className="flex items-start gap-3 rounded-xl border border-theme-border bg-surface-card p-4 text-sm"
    style={{ borderLeft: `4px solid ${cor}` }}
  >
    <span aria-hidden className="material-symbols-outlined text-[20px] leading-none" style={{ color: cor }}>
      {icone}
    </span>
    <div>
      <div className="font-semibold text-content-primary">{titulo}</div>
      <div className="mt-0.5 text-content-secondary">{children}</div>
    </div>
  </div>
);

export default Aviso;
